import { useEffect } from 'react';

/**
 * Custom hook to stop all video and audio playback
 * This ensures media doesn't continue playing after component unmount
 */
export const useVideoCleanup = () => {
  useEffect(() => {
    return () => {
      // Stop all video and audio elements on the page
      const allVideos = document.querySelectorAll('video');
      const allAudios = document.querySelectorAll('audio');
      
      allVideos.forEach(video => {
        video.pause();
        video.currentTime = 0;
        video.src = '';
        video.load();
        video.removeAttribute('src');
        // Remove all source elements
        const sources = video.querySelectorAll('source');
        sources.forEach(source => source.remove());
      });
      
      allAudios.forEach(audio => {
        audio.pause();
        audio.currentTime = 0;
        audio.src = '';
        audio.load();
        audio.removeAttribute('src');
      });
    };
  }, []);
};

/**
 * Utility function to immediately stop all videos
 * Can be called directly when needed (e.g., before navigation)
 */
export const stopAllVideos = () => {
  const allVideos = document.querySelectorAll('video');
  const allAudios = document.querySelectorAll('audio');
  
  allVideos.forEach(video => {
    video.pause();
    video.currentTime = 0;
    video.src = '';
    video.load();
    video.removeAttribute('src');
    const sources = video.querySelectorAll('source');
    sources.forEach(source => source.remove());
  });
  
  allAudios.forEach(audio => {
    audio.pause();
    audio.currentTime = 0;
    audio.src = '';
    audio.load();
    audio.removeAttribute('src');
  });
};

